import { IonCard, IonSkeletonText, IonText } from '@ionic/react'
import { useMemo } from 'react'
import { Trans } from 'react-i18next'

import type { UserQuery } from '../../../lib/apollo/types'
import { useJmtNetworksQuery, useUserQuery } from '../../../lib/apollo/types'
import { useUser } from '../../../providers/Auth/hooks'
import FollowButton from '../../Button/FollowButton'
import CustomAvatar from '../../CustomAvatar'
import type { ActivityProps } from '../ActivityProps'
import useHours from '../useHours'

import './style.scss'

const getName = (user?: UserQuery): (string | undefined) => {
    if (user?.user?.firstName && user?.user?.lastName) {
        return `${user.user.firstName} ${user.user.lastName}`
    }

    if (user?.user?.firstName) {
        return user.user.firstName
    }

    return 'Anonymous'
}

const FollowActivity: React.FC<ActivityProps> = ({ activity }) => {
    const me = useUser()
    const myAction = activity.from.id === me?.user.id.toString()

    const { data: jmtNetworks } = useJmtNetworksQuery()
    const jmtNetworkId = useMemo(() => jmtNetworks?.jmtNetworks.JMTnetworks.collection.find(jn => jn.caption === 'Join.My.Talent.Engine')?.id, [jmtNetworks])

    const { data: userData, loading } = useUserQuery({
        variables: {
            userId: myAction ? activity.targetUserId : activity.from.id,
            networkId: jmtNetworkId ?? '0',
        },
        skip: !jmtNetworkId || !me?.user.id,
    })

    const hours = useHours(activity)

    return (
        <IonCard
            className='follow-activity'
        >
            <CustomAvatar
                className='follow-activity__avatar'
                img={userData?.user?.image}
                alt={userData?.user?.id}
            />
            <IonText
                className='follow-activity__text'
                color='dark'
            >
                <Trans
                    i18nKey={`activity.${activity.type === 'FOLLOW' ? '' : 'un'}follow.${myAction ? 'you' : 'me'}`}
                    values={{
                        name: getName(userData),
                        date: hours,
                    }}
                    components={{
                        strong: !loading ? <strong /> : (
                            <IonSkeletonText
                                className='follow-activity__skeleton'
                            />
                        ),
                        date: (
                            <IonText
                                className='follow-activity__text--small'
                                color='medium'
                            />
                        ),
                    }}
                />
            </IonText>
            <FollowButton
                showProfileOnFollowed
                user={userData?.user}
                size='small'
                fill='solid'
                color='secondary'
            />
        </IonCard>
    )
}

export default FollowActivity
